<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link  to="/" class="mx-2">{{$t('myrequests.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item  almarai-bold" aria-current="page">
              <span class="mx-2">{{$t('myrequests.breadcrumb_2')}}</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">

        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

        <div class="row pt-2 myRequests display-card">
          <div class="col-auto space d-flex">
            <div class="requests"  @click.prevent="allRequests"> 
              <label class="form-check-label" for="All">
                <div :class="(dataType == 'All')? 'form-check bg-black': 'form-check' ">
                  <input class="form-check-input d-none" name="request" type="radio" id="All">
                  <span>{{$t('myrequests.allRequests')}}</span>
                </div>
              </label>
            </div>

            <div class="requests mx-2"  @click.prevent="managementFN"> 
              <label class="form-check-label" for="propertyـManagement">
                <div :class="(dataType == 'propertyManagement')? 'form-check bg-black': 'form-check' ">
                  <input class="form-check-input d-none" name="request" type="radio" id="propertyـManagement">
                  <span>{{$t('myrequests.Property_management')}}</span>
                </div>
              </label>
            </div>

            <div class="requests mx-2"  @click.prevent="Documentation"> 
              <label class="form-check-label" for="ContractDocumentation">
                <div :class="(dataType == 'documents')? 'form-check bg-black': 'form-check' ">
                  <input class="form-check-input d-none" type="radio" name="request" id="ContractDocumentation">
                  <span>{{$t('myrequests.Contract_Documentation')}}</span>
                </div>
              </label>
            </div>

            <div class="requests" @click.prevent="realEstateFinancing">
              <label class="form-check-label" for="RealEstate_Financing">
                <div :class="(dataType == 'financeRequests')? 'form-check bg-black': 'form-check' ">
                  <input class="form-check-input d-none" type="radio" name="request" id="RealEstate_Financing">
                  <span>{{$t('myrequests.RealEstate_Financing')}}</span>
                </div>
              </label>
            </div>

            <div class="requests mx-2"  @click.prevent="realEstateRequest">
              <label class="form-check-label" for="RealEstateـrequests">
                <div :class="(dataType == 'realEstateRequest')? 'form-check bg-black': 'form-check' ">
                  <input class="form-check-input d-none" type="radio" name="request" id="RealEstateـrequests">
                  <span>{{$t('myrequests.RealEstate_Requests')}}</span>
                </div>
              </label>
            </div>

            <div class="requests mx-2"  @click.prevent="photographyOrders">
              <label class="form-check-label" for="photography">
                <div :class="(dataType == 'photographyRequest')? 'form-check bg-black':'form-check'">
                  <input class="form-check-input d-none" type="radio" name="request" id="photography">
                  <span>
                    {{$t('myrequests.photographyRequests')}}
                  </span>
                </div>
              </label>
            </div>

            <div class="requests mx-2"  @click.prevent="transferRequests">
              <label class="form-check-label" for="photography">
                <div :class="(dataType == 'businessTransfer')? 'form-check bg-black':'form-check'">
                  <input class="form-check-input d-none" type="radio" name="request" id="photography">
                  <span>
                    {{$t('myrequests.transferRequests')}}
                  </span>
                </div>
              </label>
            </div>

            <div class="requests mx-2"  @click.prevent="legalConsultationsFN">
              <label class="form-check-label" for="legal">
                <div :class="(dataType == 'legalConsultations')? 'form-check bg-black':'form-check'">
                  <input class="form-check-input d-none" type="radio" name="request" id="legal">
                  <span>
                    {{$t('myrequests.legal')}}
                  </span>
                </div>
              </label>
            </div>
            <!-- begin:advertising License button -->
            <div class="requests mx-2"  @click.prevent="advertisingLicenseFN">
              <label class="form-check-label" for="legal">
                <div :class="(dataType == 'advertisingLicense')? 'form-check bg-black':'form-check'">
                  <input class="form-check-input d-none" type="radio" name="request" id="legal">
                  <span>
                    {{$t('myrequests.advertisingLicense')}}
                  </span>
                </div>
              </label>
            </div>
            <!-- end:advertising License button -->
          </div>
        </div>
        <div v-if="isLoading" class="row justify-content-center">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div v-else class="row">
          <div class="col">
            <!-- begin:allRequests  -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'All'">
              <div class="col-12 col-md-7 mb-3" v-for="(item,indexk) in requestsAll" :key="indexk">
                <div class="card requestForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="code">
                          {{$t('myrequests.orderNumber')}}
                          <span v-if="item.requestType == 'adLicenseRequests'">{{item.id}}</span>
                          <span v-if="item.requestType == 'financeRequests'">#F{{item.id}}</span>
                          <span v-if="item.requestType == 'exchangeList'">#E{{item.id}}</span>
                          <span v-if="item.requestType == 'photographyOrders'">#S{{item.id}}</span>
                          <span v-if="item.requestType == 'managementRequests'">#P{{item.id}}</span>
                          <span v-if="item.requestType == 'documents'">#D{{item.id}}</span>
                          <span v-if="item.requestType == 'propertyRequests'">#M{{item.id}}</span>
                        </div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-id-card orange-color"></i> -->
                          <span>{{$t('myrequests.title_3')}}</span>
                          <span class="marginName">{{item.name}}</span>
                        </div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-mobile-screen-button orange-color"></i> -->
                          <span>{{$t('myrequests.title_4')}}</span>
                          <span class="marginName">{{item.mobile}}</span>
                        </div>
                        <div class="request-title">
                          {{moment(item.createdAt).format('dddd D MMMM')}}
                        </div>
                        <div class="request-title" v-if="item.note">
                          <span>سيب الرفض:</span>
                          <span class="marginName">{{item.note}}</span>
                        </div>
                        <!-- <div v-else>
                          {{moment(item.createdAt).format('dddd D MMMM')}}
                        </div> -->
                      </div>
                      <div class="col-auto">
                        <div :class="(item.status == 'new')? 'status_Style status-New' : (item.status == 'waiting_payment')? 'status_Style status-New' : (item.status == 'done')? 'status_Style status-Done': (item.status == 'rejected')? 'status_Style status-Cancel' :'status_Style status-New'">
                          {{items.orderStatus[item.status]}}
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="!requestsAll" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:allRequests -->

            <!-- begin:managementRequests  -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'propertyManagement'">
              <div class="col-12 col-md-7 mb-3" v-for="(item,inddx) in managementRequests" :key="inddx">
                <div class="card requestForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="code">{{$t('myrequests.orderNumber')}} # P {{item.id}}</div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-id-card orange-color"></i> -->
                          <span>{{$t('myrequests.title_3')}}</span>
                          <span class="marginName">{{item.name}}</span>
                        </div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-mobile-screen-button orange-color"></i> -->
                          <span>{{$t('myrequests.title_4')}}</span>
                          <span class="marginName">{{item.mobile}}</span>
                        </div>
                        <div class="request-title">
                          {{moment(item.createdAt).format('dddd D MMMM')}}
                        </div>
                        <div class="request-title" v-if="item.note">
                          <span>سيب الرفض:</span>
                          <span class="marginName">{{item.note}}</span>
                        </div>
                        <!-- <div v-else>
                          {{moment(item.createdAt).format('dddd D MMMM')}}
                        </div> -->
                      </div>
                      <div class="col-auto">
                        <div :class="(item.status == 'new')? 'status_Style status-New' : (item.status == 'done')? 'status_Style status-Done': (item.status == 'rejected')? 'status_Style status-Cancel' :'status_Style status-New'">
                          {{items.managementRequestesStatus[item.status]}}
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="!managementRequests" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:managementRequests -->

            <!-- begin:documents -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'documents'">
              <div class="col-12 col-md-7 mb-3" v-for="(doc,inde) in documents" :key="inde">
                <div class="card requestForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="code">{{$t('myrequests.orderNumber')}} # D {{doc.id}}</div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-id-card orange-color"></i> -->
                          <span>{{$t('myrequests.title_3')}}</span>
                          <span class="marginName">{{doc.name}}</span>
                        </div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-mobile-screen-button orange-color"></i> -->
                          <span>{{$t('myrequests.title_4')}}</span>
                          <span class="marginName">{{doc.mobile}}</span>
                        </div>
                        <div class="request-title">
                          {{moment(doc.createdAt).format('dddd D MMMM')}}
                        </div>
                        <div class="request-title" v-if="doc.note">
                          <span>سيب الرفض:</span>
                          <span class="marginName">{{doc.note}}</span>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div :class="(doc.status == 'new')? 'status_Style status-New' : (doc.status == 'done')? 'status_Style status-Done': (doc.status == 'rejected')? 'status_Style status-Cancel' :'status_Style status-New'">
                          {{items.propertyDocumentedStatus[doc.status]}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="!documents" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:documents -->

            <!-- begin:financeRequests -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'financeRequests'">
              <div class="col-12 col-md-7 mb-3" v-for="(row,index) in financeRequests" :key="index">
                <div class="card requestForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="code">{{$t('myrequests.orderNumber')}} # F {{row.id}}</div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-id-card orange-color"></i> -->
                          <span>{{$t('myrequests.title_3')}}</span>
                          <span class="marginName">{{row.name}}</span>
                        </div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-mobile-screen-button orange-color"></i> -->
                          <span>{{$t('myrequests.title_4')}}</span>
                          <span class="marginName">{{row.mobile}}</span>
                        </div>
                        <div class="request-title">
                          <!-- <i class="fa-solid fa-money-bill-wave orange-color"></i> -->
                          <span>{{$t('myrequests.title_5')}}</span>
                          <span class="marginName">{{row.amount}}</span>
                        </div>
                        <div class="request-title">
                          {{moment(row.createdAt).format('dddd D MMMM')}}
                        </div>
                        <div class="request-title" v-if="row.note">
                          <span>سيب الرفض:</span>
                          <span class="marginName">{{row.note}}</span>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div :class="(row.status == 'new')? 'status_Style status-New' : (row.status == 'done')? 'status_Style status-Done': (row.status == 'rejected')? 'status_Style status-Cancel' :'status_Style status-New'">
                          {{items.financeStatus[row.status]}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="!financeRequests" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:financeRequests -->

            <div class="row pt-5 justify-content-center" v-if="dataType == 'realEstateRequest'">
              <div class="col-12 col-md-7 mb-3" v-for="(val,indx) in propertyRequests" :key="indx">
                <div class="card requestForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="code">{{$t('myrequests.orderNumber')}} # M {{val.id}}</div>
                        <h6 class="m-0">{{val.PropertyType.name}}</h6>
                        <div class="d-flex py-1">
                          <div>{{(val.propertyType == 'families') ? $t('myrequests.families') : $t('myrequests.single')}}</div>
                          <!-- <span class="mx-2">{{(val.purpose == 'for_rent') ? $t('rent') : (val.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span> -->
                        </div>
                        <div class="d-flex pt-1">
                          <i class="fa-solid fa-location-dot gray-color"></i>
                          <h6 class="marginName">{{val.City.name}}</h6>
                          <h6 class="mx-1">{{val.Neighborhood.name}}</h6>
                        </div>
                        <div class="request-title" v-if="val.note">
                          <span>سيب الرفض:</span>
                          <span class="marginName">{{val.note}}</span>
                        </div>
                      </div>
                      <div class="col-auto"> 
                        <div :class="(val.status == 'new')? 'status_Style status-New' : (val.status == 'done')? 'status_Style status-Done': (val.status == 'rejected')? 'status_Style status-Cancel' :'status_Style status-New'">
                          {{items.propertyRequestsStatus[val.status]}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="!propertyRequests" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>

            <!-- beign:photographyRequest -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'photographyRequest'">
              <div class="col-12 col-md-7 mb-3" v-for="(val,indx) in photography" :key="indx">
                <router-link :to="'/photographyDetails/'+val.id">
                  <div class="card requestForm">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <div class="code">{{$t('myrequests.orderNumber')}} # S {{val.id}}</div>
                          <!-- <h6 class="m-0">
                            <span>{{$t('myrequests.title_3')}}</span>
                            {{val.name}}
                          </h6>
                          <h6 class="m-0">
                            <span>{{$t('myrequests.title_4')}}</span>
                            {{val.mobile}}
                          </h6> -->
                          <h6 class="m-0">{{val.title}}</h6>
                          <div class="d-flex pt-1">
                            <i class="fa-solid fa-location-dot gray-color"></i>
                            <h6 class="mx-1">{{val.Region.name}}</h6>
                            <h6 class="marginName">{{val.City.name}}</h6>
                          </div>
                          <div class="request-title">
                            {{moment(val.createdAt).format('dddd D MMMM')}}
                          </div>
                          <div class="request-title" v-if="val.note">
                            <span>سيب الرفض:</span>
                            <span class="marginName">{{val.note}}</span>
                          </div>
                        </div>
                        <div class="col-auto"> 
                          <div :class="(val.status == 'new')? 'status_Style status-New' : (val.status == 'done')? 'status_Style status-Done': (val.status == 'client_canceled')? 'status_Style status-Cancel' :'status_Style status-New'">
                            {{items.orderStatus[val.status]}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col-12 text-center" v-if="!propertyRequests" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:photographyRequest -->

            <!-- beign:businessTransfer -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'businessTransfer'">
              <div class="col-12 col-md-7 mb-3" v-for="(val,indx) in exchangeList" :key="indx">
                <router-link :to="'/businessTransfer/'+val.id">
                  <div class="card requestForm">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <div class="code">{{$t('myrequests.orderNumber')}} # E {{val.id}}</div>
                          <!-- <h6 class="m-0">
                            <span>{{$t('myrequests.title_3')}}</span>
                            {{val.name}}
                          </h6>
                          <h6 class="m-0">
                            <span>{{$t('myrequests.title_4')}}</span>
                            {{val.mobile}}
                          </h6> -->
                          <h6 class="m-0">{{val.name}}</h6>
                          <div class="d-flex pt-1">
                            <i class="fa-solid fa-location-dot gray-color"></i>
                            <h6 class="mx-1">{{val.Neighborhood.name}}</h6>
                            <h6 class="marginName">{{val.City.name}}</h6>
                          </div>
                          <div class="request-title">
                            {{moment(val.createdAt).format('LLLL')}}
                          </div>
                          <div class="request-title" v-if="val.note">
                            <span>سيب الرفض:</span>
                            <span class="marginName">{{val.note}}</span>
                          </div>
                        </div>
                        <div class="col-auto"> 
                          <div :class="(val.status == 'new')? 'status_Style status-New' : (val.status == 'done')? 'status_Style status-Done': (val.status == 'client_canceled')? 'status_Style status-Cancel' :'status_Style status-New'">
                            {{exchangesStatus[val.status]}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col-12 text-center" v-if="!propertyRequests" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:businessTransfer -->

            <!-- beign:legalConsultations -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'legalConsultations'">
              <div class="col-12 col-md-7 mb-3" v-for="(row,indxkey) in rows" :key="indxkey">
                <router-link :to="'/lawyerRequestedDetails/'+row.id">
                  <div class="card requestForm">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <div class="code">{{$t('myrequests.orderNumber')}} # L {{row.id}}</div>
                          <div class="request-title">
                            <span>{{$t('myrequests.title_3')}}</span>
                            <span class="marginName">{{row.name}}</span>
                          </div>
                          <div class="request-title">
                            <span>{{$t('myrequests.title_4')}}</span>
                            <span class="marginName">{{row.mobile}}</span>
                          </div>
                          
                          <div class="request-title">
                            {{moment(row.createdAt).format('dddd D MMMM')}}
                          </div>
                        </div>
                        <div class="col-auto"> 
                          <div :class="(row.status == 'new')? 'status_Style status-New' : (row.status == 'done')? 'status_Style status-Done': (row.status == 'client_canceled')? 'status_Style status-Cancel' :'status_Style status-New'">
                            {{statusChoices[row.status]}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col-12 text-center" v-if="!propertyRequests" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:legalConsultations -->

            <!-- beign: advertising License data -->
            <div class="row pt-5 justify-content-center" v-if="dataType == 'advertisingLicense'">
              <div class="col-12 col-md-7 mb-3" v-for="(vale,indkey) in addLicense" :key="indkey">
                <div class="card requestForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="code">{{$t('myrequests.orderNumber')}} # {{vale.id}}</div>
                        <div class="request-title">
                          <span>{{$t('myrequests.identityNumber')}}</span>
                          <span class="marginName">{{vale.identityNumber}}</span>
                        </div>
                        <div class="request-title">
                          <span>{{$t('myrequests.title_4')}}</span>
                          <span class="marginName">{{vale.mobile}}</span>
                        </div>
                        
                        <div class="request-title">
                          {{moment(vale.createdAt).format('dddd D MMMM')}}
                        </div>
                      </div>
                      <div class="col-auto"> 
                        <div :class="(vale.status == 'new')? 'status_Style status-New' : (vale.status == 'done')? 'status_Style status-Done': (vale.status == 'client_canceled')? 'status_Style status-Cancel' :'status_Style status-New'">
                          {{statusChoices[vale.status]}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="!addLicense" >
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h4>{{$t('myrequests.title_1')}}</h4>
                <p>{{$t('myrequests.title_2')}}</p>
              </div>
            </div>
            <!-- end:advertising License data -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: "myrequests",
  data(){
    return {
      hasError: false,
      errorNumber: null,
      message: "",
      isLoading: true,
      items: {},
      dataType: this.$route.query.dataType ?? 'All',
      financeRequests: [],
      propertyRequests: [],
      managementRequests: [],
      requestsAll: [],
      documents: [],
      photography: [],
      exchangeList: [],
      exchangesStatus: {},
      rows: [],
      statusChoices: {},
      addLicense: [],
      userLang: 'ar',
      formatedDate: 'ar',
      fallbackLang: 'en',
    }
  },
  methods: {
    myRequests(){
      this.hasError = false;
      this.$http.get("/api/users/requests").then(res => {
        // console.log(res);
        this.items = res.data;
        this.requestsAll = res.data.all;
        this.financeRequests = res.data.financeRequests;
        this.propertyRequests = res.data.propertyRequests;
        this.managementRequests = res.data.managementRequests;
        this.documents = res.data.documents;
        this.photography = res.data.photographyOrders;
        this.exchangeList = res.data.exchangeList;
        this.exchangesStatus = res.data.exchangesStatus;
        this.lawyer_RequestsList();
        this.adLicenseReqList();
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    allRequests(){
      this.dataType = 'All';
    },
    managementFN(){
      this.dataType = 'propertyManagement';
    },
    Documentation(){
      this.dataType = 'documents';
    },
    realEstateFinancing(){
      this.dataType = 'financeRequests';
    },
    realEstateRequest(){
      this.dataType = 'realEstateRequest';
    },
    photographyOrders(){
      this.dataType = 'photographyRequest';
    },
    transferRequests(){
      this.dataType = 'businessTransfer';
    },
    legalConsultationsFN(){
      this.dataType = 'legalConsultations';
    },
    advertisingLicenseFN(){
      this.dataType = 'advertisingLicense';
    },
    moment,
    formatDate(){
      if(this.userLang == 'ar'){
        moment.locale(this.formatedDate);
      }else{
        moment.locale(this.fallbackLang);
      }
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },

    lawyer_RequestsList(){
      this.$http.get('/api/lawyerReq/list').then(res => {
        // console.log(res);
        this.rows = res.data.rows;
        this.statusChoices = res.data.statusChoices;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    adLicenseReqList(){
      this.$http.get('/api/adLicenseReq/list').then(res => {
        // console.log(res);
        this.addLicense = res.data.rows;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    }
  }, 
  created(){
    this.myRequests();
    this.formatDate();
    this.userLang = localStorage.getItem('lang') ??  'ar';
  },

}
</script>